import { Component, ContentChild, ContentChildren, QueryList, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-minimalist-entry',
  templateUrl: './minimalist-entry.component.html',
  styleUrls: ['./minimalist-entry.component.scss']
})
export class MinimalistEntryComponent {
  constructor() { }
}
